import React, { useContext } from 'react';
import { Center, Box, ScaleFade } from '@wegroup/design-system';
import { ToolbarItemStatus } from '../../../../../types/ProductFactory';
import { ThemeContext } from 'styled-components';

interface Props {
  status?: ToolbarItemStatus;
  show: boolean;
}

const StatusIcon: React.FC<React.PropsWithChildren<Props>> = ({
  status,
  children,
  show,
}) => {
  const theme = useContext(ThemeContext);
  return (
    <Box position="absolute" top="0" right="0">
      <ScaleFade
        initialScale={0.5}
        style={{ transition: '0.1s' }}
        in={show}
        unmountOnExit
      >
        <Center
          borderRadius="full"
          bg={
            status === ToolbarItemStatus.CHECKED
              ? theme.status.succesLight
              : theme.status.errorLight
          }
          w="6"
          h="6"
          transform="translate(25%, -25%)"
          sx={{
            svg: {
              w: '5',
              h: '5',
              '> path': {
                fill:
                  status === ToolbarItemStatus.CHECKED ? '#1B7943' : '#980606',
              },
            },
          }}
        >
          {children}
        </Center>
      </ScaleFade>
    </Box>
  );
};

export default StatusIcon;
